import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import reportWebVitals from './reportWebVitals';
import { createBrowserRouter, Navigate, RouterProvider } from 'react-router-dom';
import { Home } from './Home';
import { QueryClient, QueryClientProvider } from 'react-query';
import { About } from './About';
import { Appendix } from './Appendix';
import { Contact } from './Contact';
import { Book } from './Herbert';

const router = createBrowserRouter([
  {
    path: "/",
    element: <Home />,
    errorElement: <Home />
  },
  {
    path: "/about",
    element: <About />,
  },
  {
    path: "/archive",
    element: <Appendix />,
  },
  {
    path: "/contact",
    element: <Contact />,
  },
  {
    path: "/book",
    element: <Book />,
  },
  {
    path: "/:postId",
    element: <Home />,
    errorElement: <Navigate to="/" />
  },
]);

const queryClient = new QueryClient();

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <RouterProvider router={router} />
    </QueryClientProvider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
